module.exports = "<div class=\"d-flex flex-column\"><gmc-date-picker class=mb-1 ng-model=$ctrl.fromClone ng-change=$ctrl.getFromTo() name=\"{{'dpf' + $index}}\" max-date=\"$ctrl.toClone || $ctrl.maxDate\"></gmc-date-picker><gmc-date-picker ng-model=$ctrl.toClone name=\"{{'dpt' + $index}}\" min-date=$ctrl.fromClone max-date=$ctrl.maxDate disabled=$ctrl.disabled ng-change=$ctrl.getFromTo()></gmc-date-picker></div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/gmc-from-to-picker/gmc-from-to-picker.component.html
// module id = 881
// module chunks = 31